export function blobURLToFile(blobURL, fileName) {
  return fetch(blobURL)
    .then((r) => r.blob())
    .then((blob) => new File([blob], fileName));
}
